import { render, staticRenderFns } from "./store-creater-info.vue?vue&type=template&id=0bd3649d&scoped=true&"
import script from "./store-creater-info.vue?vue&type=script&lang=js&"
export * from "./store-creater-info.vue?vue&type=script&lang=js&"
import style0 from "./store-creater-info.vue?vue&type=style&index=0&id=0bd3649d&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bd3649d",
  null
  
)

export default component.exports